import * as Yup from "yup";

export const offlinePaymentValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email('Invalid email address').required('Email is required'),
    document: Yup.mixed().required('Document is required'),
    message: Yup.string().required('Message is required')
  });